import { History } from "lucide-react";
import ConfirmModal from "../../../confirmViewModal/ConfirmModal";
import { VERSION_HISTORY_COPY } from "../constants/versionHistory.constants";
import { VersionHistoryGroup } from "../types/versionHistory.types";
import { resolveVersionLabel } from "../utils/versionHistory.utils";

interface ActivateVersionDialogProps {
  version: VersionHistoryGroup | null;
  isActivating: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Fixes a live UX bug this replaces: the old restore modal passed neither `confirmText` nor
 * `variant`, so it rendered a red "Delete" button for a non-destructive action.
 */
export const ActivateVersionDialog = ({ version, isActivating, onConfirm, onCancel }: ActivateVersionDialogProps) => {
  const label = resolveVersionLabel(version);

  return (
    <ConfirmModal
      viewModal={!!version}
      closeModal={onCancel}
      cancel={onCancel}
      approve={onConfirm}
      title={VERSION_HISTORY_COPY.activateDialogTitle}
      subTitle={version ? VERSION_HISTORY_COPY.activateDialogBody(label) : ""}
      confirmText={VERSION_HISTORY_COPY.activateConfirm}
      variant="default"
      isLoading={isActivating}
      icon={<History className="tw-h-5 tw-w-5" />}
      testId="activate-version-dialog"
    />
  );
};
